import type { StockLotItem, StockStatusReason } from "./types";

export type StockStatusFilter = "all" | "ok" | StockStatusReason;

export const STOCK_STATUS_FILTER_OPTIONS: ReadonlyArray<{ value: StockStatusFilter; label: string }> = [
  { value: "all", label: "All Statuses" },
  { value: "ok", label: "OK / No Alert" },
  { value: "backorder", label: "Backorder" },
  { value: "out_of_stock", label: "Out of Stock" },
  { value: "expired", label: "Expired" },
  { value: "expiring_90d", label: "Expiring ≤ 90 Days" }
];

export function stockStatusValue(item: StockLotItem): Exclude<StockStatusFilter, "all"> {
  return item.status.reason ?? "ok";
}

export function filterStockItemsByStatus(
  items: StockLotItem[],
  filter: StockStatusFilter
): StockLotItem[] {
  if (filter === "all") return items;
  return items.filter((item) => stockStatusValue(item) === filter);
}
